import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { List } from "antd";
//Components
import { CardArchivo } from "./CardArchivo";
import * as ducks from "../../../../redux/aspirante/expDigitalDucks";

/**
 * Componente que muestra los documentos del expediente digital guardados por el aspirante.
 * @return {JSX.Element}
 * @author Uriel Carrión
 */
export const ListaArchivos = (props) => {
  const { idConcurso, idConvocatoria } = props.aspirante;
  const dispatch = useDispatch();
  // const { listaBandeja } = useSelector((state) => state.expDigital);
  const { catDocsPendientes, reload, loadingLista } = useSelector(
    (state) => state.expDigital
  );

  useEffect(() => {
    dispatch(ducks.getCatDocumentos(1, idConcurso, idConvocatoria));
    dispatch(ducks.getBandejaDocumentos(idConcurso, idConvocatoria));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  return (
    <div>
      <List
        className="list-archivos"
        header={
          <div className="list-header">Listado de documentos adjuntos</div>
        }
        bordered
        dataSource={catDocsPendientes}
        style={{ overflow: "auto" }}
        loading={loadingLista}
        renderItem={(item) => (
          <CardArchivo
            item={item}
            idConcurso={idConcurso}
            idConvocatoria={idConvocatoria}
          />
        )}
      />
    </div>
  );
};
